import useCreditsSubscription from '@/hooks/useCreditsSubscription';

/**
 * Session-level state syncs: SDK credits subscription. User auth is
 * established at bootstrap (entry.tsx → startAuthSync), so this hook just
 * wires reactive sync.
 */
const useSessionBootstrap = () => {
  useCreditsSubscription();
};

export default useSessionBootstrap;
